import { getFeatureIcon } from '../../utils/featureIcons';

export default function FeatureIcon({
  iconName,
  className = 'w-6 h-6',
  variant = 'outline',
}) {
  const Icon = getFeatureIcon(iconName, variant);
  return <Icon className={className} aria-hidden />;
}
